export const faq = {
  hero: {
    heading: {
      1: 'The',
      2: 'frequently asked questions',
      3: '',
    },
    description: {
      1: 'Got a question? There’s a good chance you’ll find the answer below. We’ve listed the most frequently asked questions for you, so you can continue quickly and easily on your own.',
      2: 'Still need help? Our customer service team is of course ready to assist you.'
    }
  },
  questions: {
    1: {
      question: 'What is Bistroo and how does it work?',
      answer: 'Bistroo is an innovative software company focused on the digitalization of the hospitality industry. The company provides user-friendly tools that help restaurants, cafés, and other hospitality businesses improve and manage their online presence independently.',
      bullet_title: 'Bistroo offers, among other things:',
      bullets: {
        1: 'Websites and webshops for hospitality businesses, fully customizable to your needs.',
        2: 'QR modules allowing customers to order and pay easily on-site using their phones.',
        3: 'A management system where you can configure everything yourself: menus, opening hours, promotions, delivery settings, and more.'
      },
      how: 'How does it work?',
      list: {
        1: 'You create an account with Bistroo and set up your digital environment. You can add your menu, change settings, link payment methods, and design your online restaurant.',
        2: 'Once everything is ready, your website, webshop, or QR module goes live. Customers can find you, place orders, or order on-site via QR.',
        3: 'You maintain full control of your store. Everything is configurable, but if you need help, Bistroo’s support team is ready to assist you.'
      }
    },
    2: {
      question: 'Is Bistroo free?',
      answer: 'Yes, Bistroo offers a free starter package. This means that as a hospitality entrepreneur you can use the modules without any monthly subscription fees or startup costs.',
      how: 'How does the free package work?',
      bullets: {
        1: 'Free to start: You can start setting up your webshop and website immediately, no startup costs! We only charge the cost price for QR stickers.',
        2: 'No subscription fees: We don’t charge fixed monthly fees; we only take a commission on successful orders.',
        3: 'Customizable: You have access to all basic features to fully configure your digital environment.',
        4: 'Support available: Even free users can rely on our support team.',
        5: 'Easy to switch: You can switch to another package every month.'
      },
      why: 'Why this model?',
      why_answer: 'Bistroo wants to give hospitality entrepreneurs the freedom to start digitalizing without financial barriers. Only when you achieve actual results do you pay a commission percentage. This makes it a low-threshold and fair solution for both starting and established businesses.'
    },
    3: {
      question: 'Can I try Bistroo first?',
      answer: 'Absolutely! All Bistroo packages are free to try for 30 days. This means you can use all features of the package that suits your business—whether it’s a website, webshop, or QR order module—without obligation.',
      what: 'What does the trial period include?',
      bullets: {
        1: '30 days of free access to all features of your chosen package.',
        2: 'Full freedom to set up and test your digital environment.',
        3: 'Support from the team throughout the trial.',
        4: 'Loaner hardware (if applicable) during the trial period.'
      }
    },
    4: {
      question: 'How do you handle additional requests?',
      answer: {
        1: 'At Bistroo, we take extra requests seriously. Our support team processes all incoming requests daily to ensure you get quick help and your environment remains up-to-date.',
        2: 'We also hold weekly meetings to review all feedback and requests. During these sessions, we evaluate which suggestions can be included in future feature updates.'
      }
    },
    5: {
      question: 'How do payouts work at Bistroo?',
      answer: {
        1: 'At Bistroo, payouts are simple, flexible, and fully automated.',
        2: 'In short: you stay in control of your money, and we ensure a smooth and transparent process. Easy as that.'
      },
      bullets: {
        1: 'Link your payment provider to our system.',
        2: 'Choose your payout schedule: daily, weekly, or monthly—whatever suits your business.',
        3: 'Automatic invoicing: Each payout is accompanied by an automatically generated invoice, so your admin is always up to date.'
      }
    },
    6: {
      question: 'Why should I choose you? What makes you different?',
      answer: {
        1: 'With Bistroo, you’re back in control as an entrepreneur. Our solution gives you full ownership over your online store. You become the true process owner with complete control over your online restaurant. We provide all the tools and support you need to succeed online.',
        2: 'In the Manager—our user-friendly back office—you manage everything in real-time: from menus, prices, and discounts to (refund) payments and customer data. Everything is clear and intuitive so you can focus on what really matters.',
        3: 'Bistroo also offers a unique pricing model: you choose the cost structure that fits your business. No surprises, no fine print.',
        4: 'Bistroo gives you the freedom to run your online business your way.'
      },
      bullets: {
        1: '30-day free trial',
        2: 'Monthly cancellable',
        3: 'No sneaky contracts, just clear and transparent terms'
      }
    },
    7: {
      question: 'How does it work administratively?',
      answer: {
        1: 'At Bistroo, administration is set up to be as simple as possible. For every payout, you receive an automatic revenue invoice with all necessary details. You can book it directly without hassle.',
        2: 'In short: your administration is always complete, clear, and ready for your accounting without extra manual steps.'
      }
    },
    8: {
      question: 'How long does onboarding take?',
      answer: 'With Bistroo, you’ll be online quickly: your online restaurant is fully set up and ready to go within 48 hours. That means you can start taking orders almost immediately!'
    },
    9: {
      question: 'Which payment methods do you support?',
      answer: 'Bistroo works with leading payment providers Stripe and Mollie. Through them, we support almost all common (and less common) payment methods in both the Netherlands and Belgium. Think iDEAL, Bancontact, Apple Pay, Google Pay, Credit Cards, and many more. You have full control over which payment methods you offer—just toggle them on or off via the provider portal.'
    },
    10: {
      question: 'How do we receive orders in the restaurant?',
      answer: {
        1: 'Bistroo offers several flexible options for receiving orders, tailored to what best suits your restaurant. By default, orders are delivered directly to your inbox. Notifications also appear in our Manager app or portal, and you can enable SMS alerts.',
        2: 'Want to make it even easier? We also provide hardware like receipt printers and handhelds. In many cases, we can connect your existing printers so you can start without buying new equipment.',
        3: 'We also often support POS system integrations, allowing orders to flow directly into your current workflow. This saves time and reduces processing errors.',
        4: 'In short: with Bistroo, you choose how to receive orders—completely tailored to your business operations.'
      }
    },
    11: {
      question: 'How can I start? What do I need?',
      answer: 'You can get started immediately—nothing is required. Want to get going? Simply create a free account on our website. If you need specific hardware, you can purchase it from us, but it’s absolutely not mandatory.'
    },
    12: {
      question: 'Do you charge startup costs?',
      answer: 'We don’t charge any startup fees. Only for the QR module do we pass on the cost price of the QR stickers.'
    }
  }
}
